import React, { Component } from "react";
import logo from "../logo.svg";
import arabic from "../language_ar.png";
import english from "../language_en.png";
import { ACCESS_TOKEN_NAME } from '../constants/apiContants';
import Headroom from 'react-headroom';
import store from "../store/index";
import i18n from '../i18n';
import { addArticle ,changeLanguage} from "../actions/index";
import "./Navbar.css";

export default class Navbar extends Component {

  constructor(props) {
    super(props);
    this.state = {
      lang: 'ar',
      opacity: '1'

    };
  }

  componentDidMount() {
    if (typeof window !== "undefined") {
      window.onscroll = () => {
        let currentScrollPos = window.pageYOffset;
        // console.log(maxScroll)
        if (currentScrollPos > 30) {
          this.setState({ opacity: "0" })
          // console.log(currentScrollPos)
        } else {
          this.setState({ opacity: "1" })
        }
      }
    }
  }


  changeLanguageButton = (e) => {
    //e.preventDefault();
    console.log('change language ... '+this.state.lang);
    i18n.changeLanguage(this.state.lang==='en'?'ar':'en');
    store.dispatch( changeLanguage(this.state.lang==='en'?'ar':'en') );
    this.setState({lang:this.state.lang==='en'?'ar':'en'});
    localStorage.setItem('lang',this.state.lang==='en'?'ar':'en');

  }

  render() {
    let self =this;
        store.subscribe(() =>
        { console.log('change lang'+store.getState().lang);
        localStorage.setItem('lang', store.getState().lang)

        self.setState({lang:localStorage.getItem('lang')});
        });
    return (


      <Headroom>
        <header className="top-navbar"  style={{ opacity: `${this.state.opacity}`}}>

          <nav className="navbar navbar-expand-lg navbar-light bg-light">
            <div className="container-fluid">
              {/* <a className="navbar-brand" href="index.html">
                <img style={{ maxHeight: '50px',maxWidth:'75px' }} src="https://www.mosa.gov.om/images/logo1.png" alt="" />
              </a> */}

              <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbars-host" aria-controls="navbars-rs-food" aria-expanded="false" aria-label="Toggle navigation">
                <span className="icon-bar" />
                <span className="icon-bar" />
                <span className="icon-bar" />
              </button>
              <div className="collapse navbar-collapse" id="navbars-host">
                <ul className="navbar-nav ml-auto">
                  <li className={this.props.page == 1 ? "nav-item active" : "nav-item"}><a className="nav-link" href="/welcome"  style={{ fontFamily: 'Tajawal' }}>{ i18n.t('HR1',  this.state.lang) }</a></li>
                  {localStorage.getItem(ACCESS_TOKEN_NAME) && localStorage.getItem("usertype") === "User" &&

                    <li className={this.props.page == 2 ? "nav-item active" : "nav-item"}><a className="nav-link" href="/membership"  style={{ fontFamily: 'Tajawal' }}>{ i18n.t('HR4',  this.state.lang) }</a></li>
                  }
                  {/* <li className={this.props.page == 3 ? "nav-item active" : "nav-item"}><a className="nav-link" href="#"  style={{ fontFamily: 'Tajawal' }}>{ i18n.t('HR2',  this.state.lang) }</a></li> */}
                  {/* <li className={this.props.page == 4 ? "nav-item active" : "nav-item"}><a className="nav-link" href="/contact"  style={{ fontFamily: 'Tajawal' }}>{ i18n.t('HR3',  this.state.lang) }</a></li> */}
                  {localStorage.getItem(ACCESS_TOKEN_NAME) && localStorage.getItem("usertype") !== "User" &&
                    <li className={this.props.page == 6 ? "nav-item active" : "nav-item"}><a className="nav-link" href="/createevent"  style={{ fontFamily: 'Tajawal' }}>{ i18n.t('HR5',  this.state.lang) }</a></li>
                  }
                  {localStorage.getItem(ACCESS_TOKEN_NAME) && localStorage.getItem("usertype") !== "User" &&
                    <li className={this.props.page == 5 ? "nav-item active" : "nav-item"}><a className="nav-link" href="/myaccount"  style={{ fontFamily: 'Tajawal' }}>{ i18n.t('HR6',  this.state.lang) }</a></li>
                  }
                </ul>
                <ul className="nav navbar-nav navbar-right" style={{marginRight:'0px'}}>
                  {!localStorage.getItem(ACCESS_TOKEN_NAME) &&
                    <li><a className="hover-btn-new log orange" href="/login"><span  style={{ fontFamily: 'Tajawal' }}>{ i18n.t('HR7',  this.state.lang) }</span></a></li>
                  }
                  {localStorage.getItem(ACCESS_TOKEN_NAME) &&
                    <li><a className="hover-btn-new log orange" href="/login"><span  style={{ fontFamily: 'Tajawal' }}>Logout</span></a></li>
                  }
                   <li><img style={{maxWidth:'50px',maxHeight:'50px',marginLeft:'5px'}} src={store.getState().lang==="ar"?english:arabic} onClick={e => this.changeLanguageButton(e)}/></li>
                </ul>
                <a className="site-logo" href="/welcome" rel="home">وزارة الثقافة والرياضة والشباب</a>

              </div>
            </div>
          </nav>
        </header>
      </Headroom>
    );
  }
}
